
import { defineComponent } from "vue";
import axios, { AxiosResponse } from "axios";
import qs from "qs";

interface ApplicationItem {
  id: number;
  href: string;
  avatar: string;
  title: string;
  vacancy: {
    href: string;
    title: string;
    info_driving_licence: string;
    languages: string;
    experience: string;
    cv: string;
    car: string;
  };
  company: {
    href: string;
    title: string;
  };
  interviewer: { name: string };
  status: string;
  validated: string;
  interviewer_comment: string;
}

export default defineComponent({
  name: "ListApplications",
  data() {
    return {
      applications: [] as ApplicationItem[],
      isLoading: false
    };
  },
  props: {
    user_id: {
      type: String,
      required: true,
    },
    triggerAction: {
      type: String,
      required: true,
    },
  },
  watch: {
    triggerAction(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.get_applications();
      }
    },
  },
  mounted() {
    this.get_applications();
  },
  methods: {
    get_applications() {
      const formData = new FormData();
      formData.append("action", "get_user_applications");
      formData.append("user_id", this.user_id);
      axios
        .post(window.api_settings.ajax_url, formData)
        .then((response: AxiosResponse<ApplicationItem[]>) => {
          this.applications = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    set_validated(application_id: number, value: string, interviewer_comment: string) {
      this.isLoading = true;

      const formData = new FormData();
      formData.append("action", "set_validated_application");
      formData.append("application_id", String(application_id));
      formData.append("value", value);
      formData.append("interviewer_comment", interviewer_comment);
      axios
        .post(window.api_settings.ajax_url, formData)
        .then((response: AxiosResponse<ApplicationItem[]>) => {
          // Update Vue data
          const index = this.applications.findIndex(
            (app) => app.id === application_id
          );
          if (index !== -1) {
            this.applications[index].validated = value;
            this.applications[index].status = "new";
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
});
